import React, { FC } from 'react';

import { getClassWithTheme } from 'helpers';

import { useTheme } from '..';

const AccountDataCard: FC<{ className?: string }> = ({ children, className }) => {
  let defaultClass = 'account-data-card';
  const themeMode = useTheme();

  if (className) {
    defaultClass += ` ${defaultClass}__${className}`;
  }

  return <div className={`${defaultClass} ${getClassWithTheme('account-data-card', themeMode)}`}>{children}</div>;
};

AccountDataCard.defaultProps = {
  className: undefined,
};

export default AccountDataCard;
